import React from 'react';
import { useGoogleOAuth } from '../hooks/useGoogleOAuth';
import { Loader2 } from 'lucide-react';

export const GoogleOAuthButton = () => {
  const {
    isConnected,
    isConnecting,
    userProfile,
    loading,
    connectToGoogle,
    disconnect
  } = useGoogleOAuth();

  if (loading) {
    return (
      <div className="bg-secondary border border-secondary-border rounded-lg p-6">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-secondary-border rounded-full animate-pulse"></div>
          <div>
            <div className="h-4 bg-secondary-border rounded animate-pulse w-32 mb-2"></div>
            <div className="h-3 bg-secondary-border rounded animate-pulse w-24"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-secondary border border-secondary-border rounded-lg p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {/* Google Icon */}
          <div className="w-10 h-10 bg-white rounded-full border-2 border-secondary-border flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 24 24" className="text-primary">
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-foreground">
              Google Account
            </h3>
            {isConnected ? (
              <div className="space-y-1">
                <p className="text-sm text-primary font-medium">
                  ✓ Connected
                </p>
              </div>
            ) : (
              <p className="text-sm text-muted-foreground">
                Connect your Google account to receive your booked slots directly in Google Calendar.
              </p>
            )}
          </div>
        </div>

        {/* Connect/Disconnect Button */}
        <div>
          {isConnected ? (
            <button
              onClick={disconnect}
              disabled={isConnecting}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isConnecting
                  ? 'bg-secondary-border text-muted-foreground cursor-not-allowed'
                  : 'border border-primary/20 text-primary hover:bg-primary/10'
              }`}
            >
              {isConnecting ? (
                <div className="flex items-center space-x-2">
                  <Loader2 className="w-4 h-4 animate-spin" />
                  <span>Disconnecting...</span>
                </div>
              ) : (
                'Disconnect'
              )}
            </button>
          ) : (
            <button
              onClick={connectToGoogle}
              disabled={isConnecting}
              className={`px-6 py-2 rounded-lg text-sm font-medium transition-colors ${
                isConnecting
                  ? 'bg-secondary-border text-muted-foreground cursor-not-allowed'
                  : 'bg-primary text-white hover:bg-primary/90'
              }`}
            >
              {isConnecting ? (
                <div className="flex items-center space-x-2">
                  <Loader2 className="w-4 h-4 animate-spin" />
                  <span>Connecting...</span>
                </div>
              ) : (
                'Connect to Google'
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}; 